// @ts-nocheck
import '@loyal_modules/carousel/css/owl.carousel.css'
import '@loyal_modules/carousel/css/owl.theme.default.min.css'

import { ToggleFeature, features } from 'features/ToggleFeature'

import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import TitlePrint from 'App/Shell/TitlePrint'
import ServicesContainer from 'features/Services/ServicesContainer'
import {
  SliderContainer
} from 'features/Slider'
import ShowcaseByContext from 'Catalog/Showcase/ShowcaseByContext'
import MediaQuery from 'react-responsive'
import RegulationsModalContainer from '../features/RegulationModal/RegulationsModalContainer'
import { consentCookies } from 'Shared/consentCookies'

const HomePage = ({ profile }) => {
  useEffect(() => {
    setTimeout(() => {
      window._etmc.push([
        'setUserInfo',
        {
          email: profile['custom:participant_id']
        }
      ])
      window._etmc.push(['setOrgId', '6422293'])
      window._etmc.push(['trackPageView'])
    }, 3000)
  }, [])
  return (
    <Fragment>
      <TitlePrint />

      { consentCookies() && <SliderContainer /> }

      {profile && (
        <ToggleFeature feature={features.TradeMenuHome} />
      )}

      {!process.env.REACT_APP_HEADERIUPP && (
        <RegulationsModalContainer />
      )}
      <ToggleFeature feature={features.TourGuide} />

      <ShowcaseByContext showcaseType='5' identifier='home' identifierCash='home-shopping' viewAll='/search' />

      <ToggleFeature feature={features.CategoriesShowcase} />

      <ToggleFeature feature={features.FilteredShowcase} />
      <ToggleFeature feature={features.BestOffers} />
      <ToggleFeature feature={features.AccumulatePoinstBanner} />
      <ToggleFeature feature={features.BenefitsShowcase} />

      <MediaQuery maxWidth={1024}>
        <ToggleFeature feature={features.ConnexeBanner} />
        <ToggleFeature feature={features.ConnexeBannerDFP} />

      </MediaQuery>
      <MediaQuery minWidth={1025}>
        <ToggleFeature feature={features.ConnexeBanner} />

        <ToggleFeature feature={features.ConnexeBannerDFP} />
      </MediaQuery>

      <ToggleFeature feature={features.Showcase} showcaseType='7' identifier='home' viewAll='/search?subcategory=86' />

      {profile && (
        <Fragment>
          <ServicesContainer />

          <ToggleFeature feature={features.MileageAreaHome} />
        </Fragment>
      )}
      <ToggleFeature feature={features.StoreSuggestion} />

      <ToggleFeature feature={features.CategoriesHighlightShowcase} />

      <ToggleFeature feature={features.BannersVSA} />
    </Fragment>
  )
}

HomePage.propTypes = {
  profile: PropTypes.object
}

export default HomePage



// WEBPACK FOOTER //
// ./src/HomePage/HomePage.js